<template>
    <div class="w-100 mt-2">
        <div class="w-100 darker font-weight-600 mb-4 mx-3 fs-large">Transport Details</div>

        <div class="justify-content-md-center d-flex flex-row">
            <button 
                :class="{'bg-medium': reservation.transport.transfers.length !== 1}" 
                class="btn scondary mr-2"
                :disabled="reservation.transport.transfers.length === 0 && hasTransport" 
                @click="setAsOneWay">One way</button>
            <button 
                :class="{'bg-medium': reservation.transport.transfers.length !== 2}" 
                class="btn scondary mr-2"
                :disabled="reservation.transport.transfers.length === 0 && hasTransport" 
                @click="setAsRoundTrip">Round trip</button>
            <button 
                :class="{'bg-medium': reservation.transport.transfers.length !== 0}" 
                class="btn scondary mr-2" 
                v-if="hasTransport"
                :disabled="reservation.transport.transfers.length !== 0"
                @click="setAsNoTransport">No Details</button>
            <button 
                :class="{'bg-medium': reservation.transport.transfers.length !== 0}" 
                class="btn scondary"
                v-if="!hasTransport"
                :disabled="reservation.transport.transfers.length !== 0 && hasTransport"
                @click="setAsNoTransport">No transportation</button>
        </div>

        <div class="col-sm-13 row mx-1 d-flex justify-content-between">
            <div class="col-sm-6 mb-4 mt-4" v-for="transfer,index in reservation.transport.transfers">
                <div class="bg-lighter py-3">
                    <div class="col-sm-12 dark font-weight-600 justify-content-between d-flex">
                        <span>Custom <toggle-button v-model="transfer.isCustom" :labels="{checked: 'Yes', unchecked: 'No'}" @change="isCustomChange(transfer)" :disabled="readOnly || reservation.event.eventRoutes.length === 0 || !routesByType(transfer.transportDirection).length > 0" /></span>
                        <span class="dark py-1 px-2">{{(transfer.transportDirection == 1) ? 'Pickup' : 'Drop Off'}}</span>
                    </div>

                    <div class="col-sm-12 my-2" v-if="transfer.isCustom">
                        <span v-if="getCompanySettings.settingsPresets" class="darker font-weight-600">
                            {{getCompanySettings.settingsPresets.customRouteNote}}
                        </span>
                    </div>

                    <div v-if="!transfer.isCustom">
                        <div class="col-sm-12 mt-3" v-if="!roundTrip">
                            <label>Type</label>
                            <div class="d-flex">
                                <radio name="transportType" :value="1" v-model="transfer.transportDirection" @input="oneWayTypeChanged(transfer)" class="mr-4" :disabled="readOnly">
                                    Pickup
                                </radio>
                                <radio name="transportType" :value="2" v-model="transfer.transportDirection" @input="oneWayTypeChanged(transfer)" :disabled="readOnly">
                                    Drop off
                                </radio>
                            </div>
                        </div>

                        <div class="col-sm-12 mt-3">
                            <div class="d-flex flex-row justify-content-between">
                                <label>List</label>
                                <span v-if="transfer.errorRoute" class="color-6 fs-small">Invalid</span>
                            </div>
                            <v-select :options="routesByType(transfer.transportDirection)" v-model="transfer.route" label="name" @input="setExitStop($event, transfer)" :disabled="readOnly"></v-select>
                        </div>

                        <div class="col-sm-12 mt-3" v-if="transfer.exitStop && transfer.transportDirection == 2">
                            <label>From</label>
                            <input type="text" class="d-block w-100 border-light px-2" disabled :value="iteneraryNiceOptions(transfer.route.id).length > 0? iteneraryNiceOptions(transfer.route.id)[0].name : null">
                        </div>

                        <div class="col-sm-12 mt-3" v-if="transfer.route && routes.length > 0">
                            <label>{{(transfer.transportDirection == 1) ? 'From' : 'To'}}</label>
                            <span v-if="transfer.errorStop" class="color-6 fs-small">Invalid</span>
                            <v-select :options="iteneraryOptions(transfer)" v-model="transfer.stop" @input="setSelectedLocation(transfer)" label="name" :disabled="readOnly"></v-select>
                            <div class="mt-3" v-if="transfer.stop && transfer.stop.note">
                                <label>Note</label>
                                <div>{{transfer.stop.note}}</div>
                            </div>
                        </div>

                        <div class="col-sm-12 mt-3" v-if="transfer.exitStop && transfer.transportDirection == 1">
                            <label>To</label>
                            <input type="text" class="d-block w-100 border-light px-2" disabled v-if="iteneraryNiceOptions(transfer.route.id)[iteneraryNiceOptions(transfer.route.id).length-1]" :value="iteneraryNiceOptions(transfer.route.id)[iteneraryNiceOptions(transfer.route.id).length-1].name">
                        </div>

                        <div class="d-flex">
                            <div class="col-sm-6 mt-3" v-if="transfer.stop">
                                <label>Time</label>
                                <span v-if="transfer.errorSchedule" class="color-6 fs-small">Invalid</span>
                                <v-select class="w-100" :options="possibleTimes(transfer)" v-model="transfer.schedule" @input="timeChanged(transfer)" label="timeShort" :disabled="readOnly"></v-select>
                            </div>

                            <div class="col-sm-6 mt-3" v-if="transfer.schedule">
                                <label>Date</label>
                                <datepicker input-class="bg-lightest w-100" v-model="transfer.schedule.date" format="dd.MM.yyyy" @input="dateChanged($event, transfer)"></datepicker>
                            </div>
                        </div>

                        <div class="col-sm-12 mt-3" v-if="transfer.stop && transfer.stop.notes">
                            <label>Info</label>
                            <div>{{transfer.stop.notes}}</div>
                        </div>
                    </div>

                    <div v-if="transfer.isCustom" class="col-sm-12">
                        <div class="row">
                            <div class="col-sm-12 mt-3">
                                <div class="d-flex flex-row justify-content-between">
                                    <label>From</label>
                                    <span v-if="transfer.errorRoute" class="color-6 fs-small">Invalid</span>
                                </div>
                                <input type="text" class="w-100" v-model="transfer.stop.name" :disabled="readOnly">
                            </div>

                            <div class="col-sm-12 mt-3">
                                <div class="d-flex flex-row justify-content-between">
                                    <label>To</label>
                                    <span v-if="transfer.errorStop" class="color-6 fs-small">Invalid</span>
                                </div>
                                <input type="text" class="w-100" v-model="transfer.exitStop.name" :disabled="readOnly">
                            </div>

                            <div class="col-sm-6 mt-3">
                                <div class="d-flex flex-row justify-content-between">
                                    <label>Time</label>
                                    <span v-if="transfer.errorTime" class="color-6 fs-small">Invalid</span>
                                </div>

                                <timepicker :defaultTime="customHour(transfer)" @change="setCustomTime($event, transfer)"></timepicker>
                            </div>

                            <div class="col-sm-6 mt-3">
                                <div class="d-flex flex-row justify-content-between">
                                    <label>Date</label>
                                    <span v-if="transfer.errorDate" class="color-6 fs-small">Invalid</span>
                                </div>

                                <datepicker input-class="bg-lightest w-100" v-model="transfer.schedule.date" format="dd.MM.yyyy" @input="customDateChanged($event, transfer)"></datepicker>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import Timepicker from '@/tools/Timepicker'
import extendedVSelect from '@/extends/vue-select'
import { mapGetters, mapActions } from 'vuex'

export default {
    data() {
        return {
            selectedRoute: null,
            selectedLocation: null,
            selectedSchedule: null,
            isCustomToggleVal: false,
            customTransportDefaultHour:[
                "10","00"
            ],
            isCustomVal: null,
        }
    },
    created() {
        this.isCustomVal = this.reservation.event.eventRoutes.length === 0 ? true : false;

        for (var i = 0; i < this.reservation.transport.transfers.length; i++) {
            this.$set(this.reservation.transport.transfers[i], 'errorRoute', false);
            this.$set(this.reservation.transport.transfers[i], 'errorTime', false);
            this.$set(this.reservation.transport.transfers[i], 'errorDate', false);
            this.$set(this.reservation.transport.transfers[i], 'errorStop', false);
            this.$set(this.reservation.transport.transfers[i], 'errorSchedule', false);
        }

        // We need supplier preset for the custom transpor messge, if we dont have that info we will init it
        if (!this.getCompanySettings.settingsPresets) {
            this.initCompany();
        }

        if (this.reservation.transport.transfers.length === 0) {
            this.setAsNoTransport();
        }

        this.eventHub.$on('routeForm_updateTransportTransfer', data => {
            if (data) {
                // If transport added set one way
                this.setAsOneWay();
            } else {
                // If has no transport added set as no transport
                this.setAsNoTransport();
            }
        })

        this.addNotesToTransport();
    },
    props: {
        routes: {
            type: Array,
            default: []
        },
        reservation: {
            type: Object
        },
        type: {
            type: Number,
            default: 1
        },
        title: {
            type: String,
            default: 'Transport'
        },
        readOnly: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapGetters([
            'getCompanySettings'
        ]),
        roundTrip() {
            return this.reservation.transport.transfers.length > 1;
        },
        transportDate() {
            return moment(this.reservation.event.start).format("DD.MM.YYYY");
        },
        hasTransport() {
            return this.reservation.event.eventComponents.some((book) => book.component.componentType === 1);
        },
    },
    methods: {
        ...mapActions([
            'initCompany'
        ]),
        iteneraryOptions(transfer) {
            if (!transfer || !transfer.route || !transfer.route.id) {
                return [];
            }

            const options = this.iteneraryNiceOptions(transfer.route.id) || [];
            let slicedOptions = [];

            if (transfer.transportDirection === 1) {
                slicedOptions = options.slice(0, -1);
            } else {
                slicedOptions = options.slice(1);
            }

            return slicedOptions;
        },
        addNotesToTransport() {
            if (this.reservation.transport.transfers && this.reservation.transport.transfers.length > 0) {
                this.reservation.transport.transfers.forEach(transfer => {
                    if (transfer && transfer.route && transfer.stop) {
                        const routeSelected = this.routes.find(route => route.id === transfer.route.id);
                       
                        if (routeSelected && routeSelected.iteneraries) {
                            const itenerary = routeSelected.iteneraries.find(ite => ite.stop.id === transfer.stop.id);
                            
                            if (itenerary) {
                                transfer.stop.note = itenerary.note;
                            }
                        }
                    }
                });
            }
        },
        isCustomChange(transfer) {
            if(transfer.isCustom){
                transfer.route = null;
                this.$set(transfer, 'errorRoute', false);
                this.$set(transfer, 'errorSchedule', false);
                this.$set(transfer, 'errorStop', false);
                this.$set(transfer, 'stop', {name:null});
                this.$set(transfer, 'exitStop', {name:null});
                this.$set(transfer, 'schedule', {date: moment(this.reservation.event.start).format('YYYY-MM-DD HH:mm:ss'), time: this.customTransportDefaultHour[0]+':'+this.customTransportDefaultHour[1]+':00'});
            } else {
                this.$set(transfer, 'errorRoute', false);
                this.$set(transfer, 'errorTime', false);
                this.$set(transfer, 'errorDate', false);
                this.$set(transfer, 'errorStop', false);
                this.$set(transfer, 'stop', null);
                this.$set(transfer, 'exitStop', null);
                this.$set(transfer, 'schedule', null);
            }
        },
        routesByType(type) {
            return this.reservation.event.eventRoutes.filter(route => {
                return route.type == type;
            })
        },
        setAsOneWay() {
            const isCustomVal = !this.routesByType(1).length > 0;

            if (this.readOnly) {
                return false;
            }

            if (this.reservation.transport.transfers.length == 2) {
                this.reservation.transport.transfers.splice(1,1);
            } else {
                this.reservation.transport.transfers = [
                    {
                        order: 0,
                        transportDirection: 1,
                        isCustom: isCustomVal,
                        route: null,
                        stop: isCustomVal ? { name: null } : null,
                        exitStop: isCustomVal ? { name: null } : null,
                        schedule: isCustomVal ? { date: moment(this.reservation.event.start).format('YYYY-MM-DD HH:mm:ss'), time: this.customTransportDefaultHour[0]+':'+this.customTransportDefaultHour[1]+':00' }: null,
                    }
                ]
            }
        },
        setAsRoundTrip() {
            const isCustomOneWay = !this.routesByType(1).length > 0;
            const isCustomRoundTrip = !this.routesByType(2).length > 0;

            if (this.readOnly) {
                return false;
            }

            if (this.reservation.transport.transfers.length == 0) {
                // Creates 2 transfer with different directions
                this.reservation.transport.transfers = [
                    {
                        order: 0,
                        transportDirection: 1,
                        isCustom: isCustomOneWay,
                        route: null,
                        stop: isCustomOneWay ? {name: null} : null,
                        exitStop: isCustomOneWay ? {name: null} : null,
                        schedule: isCustomOneWay ? {date: moment(this.reservation.event.start).format('YYYY-MM-DD HH:mm:ss'), time: this.customTransportDefaultHour[0]+':'+this.customTransportDefaultHour[1]+':00'}: null,
                    },
                    {
                        order: 0,
                        transportDirection: 2,
                        isCustom: isCustomRoundTrip,
                        route: null,
                        stop: isCustomRoundTrip ? {name: null} : null,
                        exitStop: isCustomRoundTrip ? {name: null} : null,
                        schedule: isCustomRoundTrip ? {date: moment(this.reservation.event.start).format('YYYY-MM-DD HH:mm:ss'), time: this.customTransportDefaultHour[0]+':'+this.customTransportDefaultHour[1]+':00'}: null,
                    }
                ]
            } else if (this.reservation.transport.transfers.length == 1) {
                if (this.reservation.transport.transfers[0].transportDirection == 2) {
                    this.resetTransfer(0, 1);
                }

                this.reservation.transport.transfers.push(
                    {
                        order: 0,
                        transportDirection: 2,
                        isCustom: isCustomRoundTrip,
                        route: null,
                        stop: isCustomRoundTrip ? {name: null} : null,
                        exitStop: isCustomRoundTrip ? {name: null} : null,
                        schedule: isCustomRoundTrip ? {date: moment(this.reservation.event.start).format('YYYY-MM-DD HH:mm:ss'), time: this.customTransportDefaultHour[0]+':'+this.customTransportDefaultHour[1]+':00'}: null,
                    }
                )
            }
        },
        resetTransfer(transferIndex, transportDirection) {
            const isCustomVal = !this.routesByType(transportDirection).length > 0;

            this.reservation.transport.transfers[transferIndex] = {
                order: 0,
                transportDirection: transportDirection,
                isCustom: isCustomVal,
                route: null,
                stop: isCustomVal ? {name: null} : null,
                exitStop: isCustomVal ? {name: null} : null,
                schedule: isCustomVal ? {date: moment(this.reservation.event.start).format('YYYY-MM-DD HH:mm:ss'),time: this.customTransportDefaultHour[0]+':'+this.customTransportDefaultHour[1]+':00'}: null,
            }
        },
        setAsNoTransport() {
            if (this.readOnly) {
                return false;
            }

            this.reservation.transport.transfers = [];
        },
        iteneraryNiceOptions(routeId) {
            if (routeId == null) {
                return null;
            }

            let selectedRoute = this.routes.filter(route => {
                return routeId == route.id;
            })[0]

            if (!selectedRoute) {
                return [];
            }

            let possibleStops = [];

            for(let itenerary of selectedRoute.iteneraries){
                let possibleStop = itenerary.stop;
                possibleStop.note = itenerary.note;
                possibleStops.push(possibleStop);
            }

            return possibleStops;
        },
        setExitStop($event, transfer) {
            if (!transfer || this.routes.length == 0) {
                return [];
            }

            if (transfer.transportDirection == 1) {
                if(transfer.route){
                    transfer.exitStop = transfer.route.routeDestination;
                } else {
                    transfer.exitStop = null;
                    transfer.stop = null;
                    transfer.schedule = null;
                    
                    return false;
                }
            } else if (transfer.transportDirection == 2) {
                if (transfer.route) {
                    transfer.exitStop = transfer.route.routeDestination;
                } else {
                    transfer.exitStop = null;
                    transfer.stop = null;
                    transfer.schedule = null;
                    
                    return false;
                }
                
                transfer.exitStop = this.findAvailableRouteById(transfer.route.id).iteneraries[0].stop;
            }

            // Check if current selected stop is valid for selected route, if not clears it
            let selectedRouteIteneraries = this.findAvailableRouteById(transfer.route.id).iteneraries
            let findStopInIteneraries = selectedRouteIteneraries.filter(itenerary => {
                if (transfer.stop) {
                    return itenerary.stop.id == transfer.stop.id;
                }
            });

            if (findStopInIteneraries.length == 0){ 
                transfer.stop = null;
            }

            // Just a patch
            this.$forceUpdate(); 
        },
        setSelectedLocation(transfer) {
            this.$forceUpdate();
        },
        setCustomTime($event, transfer) {
            transfer.schedule.time = $event+':00';
            transfer.schedule.timeShort = $event;

            // updates date
            let date = transfer.schedule.date.split(' ')[0];
            transfer.schedule.date = date + ' ' + transfer.schedule.time;
            transfer.schedule.dateTimeLong = transfer.schedule.date;

        },
        findAvailableRouteById(routeId) {
            return this.routes.filter(route => {
                return routeId == route.id;
            })[0];
        },
        possibleTimes(transfer) {
            if (!transfer || this.routes.length == 0 || !transfer.route) {
                return [];
            }

            let routeId = transfer.route.id;

            let selectedRoute = this.routes.filter(route => {
                return routeId == route.id;
            })[0];

            if (!selectedRoute) {
                return [];
            }

            if (transfer.transportDirection == 1) {
                // is pickup so shows the times for the selectedStop
                var selectedStop = selectedRoute.iteneraries.filter(itenerary => {
                    return transfer.stop.id == itenerary.stop.id;
                })[0];
            } else if (transfer.transportDirection == 2) {
                // is drop off so shows the times for the fist stop (here the passager enters for the dropoff)
                var selectedStop = selectedRoute.iteneraries[0];
            }

            return selectedStop.schedules;
        },
        customHour(transfer) {
            if (transfer.schedule.timeShort) {
                return transfer.schedule.timeShort.split(":");
            } else {
                return this.customTransportDefaultHour;
            }
        },
        customDateChanged(e, transfer) {
            transfer.schedule.date = moment(e).format('YYYY-MM-DD HH:mm:ss');
        },
        dateChanged(e, transfer) {
            let dateString = moment(e).format('YYYY-MM-DD') + ' ' + transfer.schedule.time;
            transfer.date = dateString;
            transfer.schedule.date = dateString;
        },
        oneWayTypeChanged(transfer) {
            if (transfer.transportDirection == 1) {
                // Pickup
                transfer.route = null;
                transfer.exitStop = null;
                transfer.schedule = null;
            } else {
                // Dropoff
                transfer.route = null;
                transfer.exitStop = null;
                transfer.schedule = null;
            }
        },
        timeChanged(transfer) {
            if (!transfer.date) {
                transfer.schedule.date = moment(this.reservation.event.start).format('YYYY-MM-DD') + ' ' + transfer.schedule.time;
            } else {
                let currentDate = transfer.date.split(" ")[0];
                transfer.schedule.date = currentDate + ' ' + transfer.schedule.time;
            }

            this.$forceUpdate();
        }
    },
    components: {
        vSelect: extendedVSelect,
        Datepicker,
        Timepicker,
    }
}
</script>

<style lang="scss">
    @import '../../../../../assets/scss/_variables.scss';

    textarea[disabled], input[disabled] {
        color: $dark !important;
    }
</style>



// WEBPACK FOOTER //
// RouteForm.vue?c775bdd2